import { render, staticRenderFns } from "./IconCritical.vue?vue&type=template&id=750e69e2"
import script from "./IconCritical.vue?vue&type=script&lang=js"
export * from "./IconCritical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports